import React, { useEffect, useState } from 'react'
import '../../Assests/css/studentApplicationById.css'
import educatorimage from '../../Assests/images/educator_image.jpg'
import icon from '../../Assests/images/studentapplicationbyid_icon.png'
import {
    UserGroupIcon,
    Squares2X2Icon,
    ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import StatCard from '../../components/StatCard';
import StudentApplicationTable from '../../components/StudentApplicationTable';
import { applications, applicationTableHeaders } from '../../components/StudentDasbordData';
import FeedbackForm from '../../components/FeedbackForm';
import InquiryForm from '../../components/InquiryForm';
import { applicationService } from '../../services/applicationService';
import { useParams } from 'react-router-dom';
import helpers from '../../utils/helpers';
import fallBackImage from '../../Assests/images/placeholderimage.jpg'

export default function StudentApplicationById({ userRole }) {
    const [staticCardData, setStaticCardData] = useState([
        {
            id: 1,
            title: "Last Activity",
            value: "you last played 2 days ago",
            icon: UserGroupIcon,
            arrowColor: "text-blue-600",
        },
        {
            id: 2,
            title: "Next Milestone",
            value: "Complete 2 more level of application ",
            icon: Squares2X2Icon,
            arrowColor: "text-green-600",
        },
        {
            id: 3,
            title: "Performance",
            value: "currently You performance is Average",
            icon: ClipboardDocumentListIcon,
            arrowColor: "text-orange-600",
        },
    ])
    const [applicationDetail, setApplicationDetail] = useState([])
    const [studentApplications, setStudentApplications] = useState([])
    const [openFeedBackForm, setOpenFeedBackform] = useState(false)
    const [openInquiryForm, setOpenInquiryForm] = useState(false)


    let params = useParams()
    let decryptId = helpers.decryptId(params.id)

    useEffect(() => {
        getStudentApplicationDetailById()
    }, [decryptId])

    async function getStudentApplicationDetailById() {
        try {
            let data = JSON.stringify({
                'id': decryptId
            })
            let response = null
            if (userRole?.role_name == 'Student') {
                response = await applicationService.getStudentApplicationDetailById(data)
            } else {
                response = await applicationService.getFamilyApplicationDetailById(data)
            }
            if (response?.success == true) {
                setApplicationDetail(response?.data?.application)
                setStudentApplications(response?.data?.applications)
            } else {
                setApplicationDetail([])
                setStudentApplications([])
            }
        } catch (e) {
            throw e
        }
    }


    return (
        <>
            <div className='student_applicationbyId_main'>
                <div className='card student_applicationbyId_Details'>
                    <div className='student_applicationbyId_Details_inner'>
                        <div className='student_applicationbyid_iconsec'>
                            <img src={applicationDetail?.icon || fallBackImage} alt={applicationDetail?.name}
                                className='rounded-lg'
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = fallBackImage;
                                }} />
                        </div>
                        <div className='student_applicationbyid_content'>
                            <div>
                                <h4 className='student_applicationbyid_label'>{applicationDetail?.name}</h4>
                                <div className='student_applicationbyid_Tags'>
                                    {applicationDetail?.subject_name &&
                                        <div className='student_tags_inner student_tag_language'>
                                            <p>{applicationDetail?.subject_name}</p>
                                        </div>
                                    }
                                    {applicationDetail?.grade_name &&
                                        <div className='student_tags_inner student_tag_grade'>
                                            <p>{applicationDetail?.grade_name}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='student_applicationbyid_location'>
                                <div>
                                    <label>Location</label>
                                    <p>{applicationDetail?.location}</p>
                                </div>
                                <div>
                                    <label>Launch Date</label>
                                    <p>{applicationDetail?.launch_date}</p>
                                </div>
                                <div>
                                    <label>Usage Hours</label>
                                    <p>{applicationDetail?.usage_hours}</p>
                                </div>
                            </div>
                            <div className='student_applicationbyid_educator_sec'>
                                <label>Educator</label>
                                <div className='student_applicationbyid_educator_detail'>
                                    <div className='student_applicationbyid_educator_image'>
                                        <img src={applicationDetail?.profile_pic || fallBackImage} alt={applicationDetail?.full_name}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = fallBackImage;
                                            }}
                                        />
                                    </div>
                                    <div className='student_applicationbyid_educator_content'>
                                        <h4>{applicationDetail?.full_name}</h4>
                                        <p>ID: {applicationDetail?.educator_id}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='student_applicationbyid_progressBar_sec'>
                                <label>Status</label>
                                <div className='student_applicationbyid_check_application' style={{ justifyContent: applicationDetail?.completion_score == '100%' ? 'end' : 'space-between' }}>
                                    <p>Session Length: {applicationDetail?.simulated_session_length_minutes}m</p>
                                    <p>{applicationDetail?.completion_score} Complete</p>
                                </div>
                                <div className='applicationbyid_progress_bar_main'>
                                    <div className="w-full bg-gray-200 rounded-full h-2">
                                        <div
                                            className={`h-2 rounded-full`}
                                            style={{ width: applicationDetail?.completion_score, background: applicationDetail?.completion_score >= '90%' ? 'rgb(22, 163, 74)' : '#FFA21D' }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='student_applicationbyid_btn_sec'>
                        <div>
                            {/* <button className='student_applicationbyid_status'>Resume</button> */}
                            {userRole?.role_name == 'Student' &&
                                <button className='student_applicationbyid_status' style={{ background: applicationDetail?.simulated_session_length_minutes ? '#496EB4' : applicationDetail?.completion_score == '100%' ? '#16A34A' : '#71757633', color: applicationDetail?.simulated_session_length_minutes ? '#fff' : applicationDetail?.completion_score == '100%' ? '#fff' : '#717576' }}>{applicationDetail?.simulated_session_length_minutes ? 'In progress'
                                    : applicationDetail?.completion_score == '100%' ? 'Completed' : 'Not started'}</button>
                            }

                            {userRole?.role_name == 'Family' &&
                                <button className='student_applicationbyid_status' style={{ background: '#496EB4', color: '#fff' }}>Export Report</button>
                            }
                        </div>

                        {userRole?.role_name == 'Student' &&
                            <div>
                                <button className='student_applicationbyid_feedback' onClick={() => setOpenFeedBackform(true)}>Feedback</button>
                            </div>
                        }

                        {userRole?.role_name == 'Family' &&
                            <div>
                                <button className='student_applicationbyid_feedback' onClick={() => setOpenInquiryForm(true)}>Inquiry Request</button>
                            </div>
                        }
                    </div>
                </div>
                <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 mt-5'>
                    {staticCardData.map((stat) => (
                        <StatCard
                            key={stat.id}
                            icon={stat.icon}
                            title={stat.title}
                            value={stat.value}
                            arrowColor={stat.arrowColor}
                            link={stat.link}   // ✅ add this
                        />
                    ))}
                </div>
                <div className="card p-4 mt-5">
                    <h2 className="text-md  mb-4 text-[#717576]">Other Applications</h2>
                    <StudentApplicationTable applications={studentApplications} headers={applicationTableHeaders} />
                </div>
                <FeedbackForm openFeedBackForm={openFeedBackForm} setOpenFeedBackform={setOpenFeedBackform} />
                <InquiryForm openInquiryForm={openInquiryForm} setOpenInquiryForm={setOpenInquiryForm} />
            </div>
        </>
    )
}
